import React from 'react';

import classNames from 'classnames';

import { Title, TitleProps } from '../title';

export interface BlockProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  blockTitle?: string | TitleProps;
  aside?: React.ReactNode;
  direction?: 'col' | 'row';
}

export const Block = ({
  blockTitle,
  aside,
  children,
  className,
  direction = 'col',
  ...props
}: React.PropsWithChildren<BlockProps>) => (
  <div
    className={classNames(
      'anc-form-block',
      { 'flex-col': direction === 'col' },
      { 'flex-row': direction === 'row' },
      className
    )}
    {...props}
  >
    {(aside || blockTitle) && (
      <div className="flex items-center justify-between">
        {blockTitle && (
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {typeof blockTitle === 'string' ? (
              <Title size="sm" title={blockTitle} />
            ) : (
              <Title {...blockTitle} />
            )}
          </>
        )}
        {aside}
      </div>
    )}
    {children}
  </div>
);
